import {formatPrice} from '../../../utils/common'

export const parseCustomerGroupReportRow = (row: any) => ({
  id: row.customer_group_id,
  customerGroupId: row.customer_group_id || '-',
  customerGroupName: row.customer_group_name || '-',
  orderCount: row.total_order_count || 0,
  totalShipping: formatPrice(row.total_shipping, false) || 0,
  contributionSalePercentage: `${row.contributed_revenue_percentage}%` || '0%',
  contributedShippingPercentage: `${row.contributed_shipping_percentage}%` || '0%',
})

export const parseCustomerTypeReportRow = (row: any) => ({
  id: row.id,
  customerType: row.customer_type || '-',
  orderCount: row.total_order_count || 0,
  totalShipping: formatPrice(row.total_shipping, false) || 0,
  contributedShippingPercentage: `${row.contributed_shipping_percentage}%` || '0%',
})

export const parseSalesRepTypeReportRow = (row: any) => ({
  id: row.id,
  salesRepType: row.sales_rep_type || '-',
  orderCount: row.total_order_count || 0,
  totalShipping: formatPrice(row.total_shipping, false) || 0,
  contributedShippingPercentage: `${row.contributed_shipping_percentage}%` || '0%',
})

export const parseSalesRepReportRow = (row: any) => ({
  id: row.id,
  salesRep: row.rep_name || '-',
  salesRepEmail: row.rep_email || '-',
  salesRepType: row.rep_type || '-',
  orderCount: row.total_order_count || 0,
  totalShipping: formatPrice(row.total_shipping, false) || 0,
  contributedShippingPercentage: `${row.contributed_shipping_percentage}%` || '0%',
})
